import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-page-heading',
  templateUrl: './page-heading.component.html',
  styleUrls: ['./page-heading.component.scss']
})
export class PageHeadingComponent implements OnInit {
  @Input('title') title = '';
  @Input('backUrl') backUrl: string;
  @Input('nav') nav: any[];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/page-heading/page-heading.component.ts